@import 'apps/webcomponents/src/assets/widget-shared.scss';
@import 'apps/webcomponents/src/assets/common.scss';

:host {
  background-color: var(--white-layout-302-level-1-elevation);
  color: var(--main-titles-inputs-600);
  padding-top: calc(var(--spacer) * 1.5);
}

.wrapper {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;

  &.is-loading {
    .threats-list {
      display: none;
    }
  }
}

.widget-loading {
  bottom: calc(var(--spacer) * 3);
}

.content {
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.threats-list {
  width: 100%;

  li {
    margin-bottom: 0;
  }
}

.wrapper {
  .content {
    .gz-data-item {
      &--value {
        color: var(--main-titles-inputs-600);
      }

      &--delta {
        font-weight: bold;

        &.success {
          color: var(--green-layout-101-primary-green);
        }
      }
    }
  }
}

:host([data-display-mode='pdf']) {
  .wrapper {
    .content {
      .gz-data-item {
        font-size: calc(var(--body-size) - 2px);
      }
      .gz-data-item--value {
        margin-bottom: auto;
        margin-top: auto;
        font-size: var(--body-size);
      }
    }
  }
}
